export default {"src":"/_next/static/media/jumping.3af6c854.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};